import React from 'react';
import { useState, useEffect } from 'react';
import { AppointmentSetting, ButtonComponent, InvitationModal ,Schoolsetupappointment } from 'tutorapp-components';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { apiService } from '../utils/apiRequest';
import { toast } from 'react-toastify';
import Lottie from 'lottie-react';
import CircularProgress from '@mui/material/CircularProgress';
import { setSchoolRepeat, setSchoolSessionType, resetSchoolAppointmentState } from '../redux/actions/schoolPresetValuesActions';

export default function Schoolappointmentsetupscreen() {


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [sessionType, setSessionType] = useState(null); // Track session type
  const [repeat, setRepeat] = useState(null); // Track repeat option
  const [loading, setLoading] = useState(false);
  const [appointmentid, setAppointmentid] = useState('')
  const [showCelebration, setShowCelebration] = useState(false);


  const schoolAppointmentId = useSelector(state => state.schoolPresetValues.schoolAppointmentId);
  const schoolDate = useSelector(state => state.schoolPresetValues.schoolDate);
  const schoolTime = useSelector(state => state.schoolPresetValues.schoolTime);
  const schoolSessionsPerWeek = useSelector(state => state.schoolPresetValues.schoolSessionsPerWeek);
  const schoolSessionType = useSelector(state => state.schoolPresetValues.schoolSessionType);
  const schoolRepeat = useSelector(state => state.schoolPresetValues.schoolRepeat);
  const schoolSubjectId = useSelector(state => state.schoolPresetValues.schoolSubjectId);
  const schoolAppointmentType = useSelector(state => state.schoolPresetValues.schoolAppointmentType);
  const schoolJobValue = useSelector(state => state.schoolPresetValues.schoolJobValue);
  const selectedStudent = useSelector(state => state.schoolPresetValues.schoolSelectedStudent);
  const selectedFranchise = useSelector((state) => state.franchise?.selectedFranchise);
  const schoolAppointment = useSelector((state) => state.schoolAppointment.schoolAppointment);
  const tutoradress = selectedStudent?.[0]?.tutor_address || '';

  const icons = {
    backarrow: './images/ic_back.svg',
    address: './images/ic_tutoring_address.svg',
    repeat: './images/ic_repeat.svg',
    sessionappointment: './images/ic_sessionappointment.svg',
    close: './images/ic_close.svg',
    progress: './images/ic_4.svg',
    modalclose: './images/ic_close2.svg',

  };


  const formatTime = (time) => {
    return time ? `${time}:00` : '';
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Helper function to calculate duration in seconds from time.start and time.end
  const calculateDurationInSeconds = (start, end) => {
    if (!start || !end) return 0;

    const [startHours, startMinutes] = start.split(':').map(Number);
    const [endHours, endMinutes] = end.split(':').map(Number);

    const startSeconds = startHours * 3600 + startMinutes * 60;
    const endSeconds = endHours * 3600 + endMinutes * 60;

    return endSeconds - startSeconds; // Duration in seconds
  };

  // Helper function to calculate repeat_count
  const calculateRepeatCount = () => {
    const remaining_hrs = schoolJobValue?.remaining_hours || 0;
    const durationSeconds = calculateDurationInSeconds(schoolTime?.start, schoolTime?.end);

    if (durationSeconds <= remaining_hrs) return 0; // Avoid division by zero or invalid duration

    const remainingSeconds = remaining_hrs * 3600; // Convert hours to seconds
    const repeat_count = Math.floor(remainingSeconds / durationSeconds); // Integer division

    return repeat_count;
  };

  const repeat_count = calculateRepeatCount();

  const handleschoolappointment = (data) => {
    createAppointment(data).then(() => setShow(true)); // Show modal on success

    const repeatData = {
      choice: data?.repeat?.repeat,
      frequency: data?.repeat?.frequency,
      occurrences: data?.repeat?.occurrences,
      days: data?.repeat?.days
    };
    // dispatch(setRepeat(repeatData))
    dispatch(setSchoolSessionType(data.session_type))
    dispatch(setSchoolRepeat(repeatData))



  };

  const createAppointment = async (appointmentData) => {
    try {
      setLoading(true);

      const createAppointmentUrl = process.env.REACT_APP_API_URL + 'createAppointment';
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          franchise_id: selectedFranchise.franchise_id,
          job_id: schoolJobValue.id,
          tutor_id: selectedFranchise.tutor_id,
          student_id: schoolAppointmentId,
          appointment_type: schoolAppointmentType.appointment_type,
          subject_id: schoolSubjectId[0].id,
          appointment_date: formatDate(schoolDate),
          appointment_start_time: formatTime(schoolTime.start),
          appointment_end_time: formatTime(schoolTime.end),
          session_type: appointmentData.session_type,
          repeat_choice: !appointmentData.repeat?.repeat || appointmentData.repeat?.repeat === "None" ? "" : appointmentData.repeat?.repeat,
          repeat_frequency: appointmentData.repeat?.frequency || "",
          repeat_occurences: appointmentData.repeat?.occurrences || "",
          weeks: appointmentData.repeat?.days || "",
        }),
      };
      const response = await apiService(createAppointmentUrl, options);
      if (response.status == 'success') {
        dispatch(resetSchoolAppointmentState());
        setShowCelebration(true);

        if (selectedFranchise.send_external_cal_invitation === '1') {
          setAppointmentid(response.appointment_id)
          setShow(true);
        }

        else {

          navigate("/MyAppointment")
        }

      } else {
        console.error('Failed to create appointment:', response.message);
        toast.error(response.message, {
          autoClose: false,
          position: "top-center",
          autoClose: 5000,
          closeOnClick: true,
          hideProgressBar: true, // Hides the bottom timer line
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" } // Custom Red Background



        });
        throw new Error(response.message);
      }
    } catch (error) {
      console.error('Error while creating appointment:', error);
      toast.error(error, {
        autoClose: false,
        position: "top-center",
        autoClose: 5000,
        closeOnClick: true,
        hideProgressBar: true, // Hides the bottom timer line
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
        style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" } // Custom Red Background



      });
      throw error;
    }
    finally {
      setLoading(false);
    }
  };

  const sendinvitation = async (appointmentid) => {
    setLoading(true); // Start loading
    try {
      const endpoint = process.env.REACT_APP_API_URL + 'getCalendarEmail';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ appointment_id: appointmentid }),
      };

      const response = await apiService(endpoint, options);

      if (response.status === 'success') {
        navigate("/MyAppointment")


      } else {
        toast.error(response.message || "Failed to fetch student names", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
        });
      }
    } catch (error) {
      console.error("Error fetching student names:", error);
      toast.error("An error occurred while fetching student names", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
        style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" }
      });
    } finally {
      setLoading(false); // Stop loading
    }
  };


  const handleback = () => {
    navigate('/schooldatetime');
  };

  const handlehide = () => {
    setShow(false);
  };

  const onsend = () => {
    sendinvitation(appointmentid)
    setShow(false);
  };

  const oncancel = () => {
    setShow(false);
    navigate("/MyAppointment")
  };

  const onarrowclick = () => {
    navigate('/editAppointment');
  };

  const ondelete = () => {
  };

  // Handle session type and repeat selection
  const handleSessionTypeSelect = (type) => {
    setSessionType(type);
  };

  const handleRepeatSelect = (option) => {
    setRepeat(option);
  };


  const handleselectionclose = () => {

    navigate("/MyAppointment")
  }


  // Check if all required values are selected
  const isContinueDisabled = !sessionType;

  return (
    <div>

      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <CircularProgress
            size={48}
            sx={{ color: 'black' }}
            aria-label="Loading"
          />
        </div>
      )}

      <Schoolsetupappointment
        handleback={handleback}
        handleschoolappointment={handleschoolappointment}
        onarrowclick={onarrowclick}
        icons={icons}
        onSessionTypeSelect={handleSessionTypeSelect} // Pass session type handler
        onRepeatSelect={handleRepeatSelect} // Pass repeat handler
        isContinueDisabled={isContinueDisabled} // Pass disabled state
        sessionTypes={schoolSessionType} // Pass selected session type
        repeat={repeat} // Pass selected repeat
        repeatappointmentlimit={selectedFranchise?.limit_for_schools}
        handleselectionclose={handleselectionclose}
        tutoradress={tutoradress}
        repeat_count={
          repeat_count >= selectedFranchise?.limit_for_schools
            ? selectedFranchise?.limit_for_schools
            : repeat_count
        }
      />
      <InvitationModal isVisible={show} onClose={handlehide} onsend={onsend} oncancel={oncancel} />
      {showCelebration && (
        <>
          <Lottie
            animationData={require("../assets/celebration.json")}
            style={{
              position: 'absolute',
              width: 300,
              height: 300,
              top: '50%',
              left: 0,
              transform: 'translateY(-50%)',
            }}
          />
          <Lottie
            animationData={require("../assets/celebration.json")}
            style={{
              position: 'absolute',
              width: 300,
              height: 300,
              top: '50%',
              right: 0,
              transform: 'translateY(-50%)',
            }}
          />
        </>
      )}

    </div>
  );
}